var React = require('react');

function CheckmarkIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#6677FB","key":0}),React.createElement("path",{"d":"M23 12.008L20.048 10l-5.532 7.224-3.387-2.312L9 17.697 15.323 22v-.015l.016.015L23 12.008z","fill":"#fff","key":1})]);
}

CheckmarkIcon.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = CheckmarkIcon;

CheckmarkIcon.default = CheckmarkIcon;
